import React from "react";
import PropTypes from "prop-types";

import Menu from "components/Menu";

export function FormFieldMenu({
  onAddFormFieldAbove,
  onEnableEditMode,
  onDelete,
}) {
  return (
    <Menu>
      {({ closeMenu }) => {
        return (
          <React.Fragment>
            <Menu.Button
              onClick={() => {
                onAddFormFieldAbove();
                closeMenu();
              }}
              content="Add Form Field Above"
              icon="clipboard list"
            />
            <Menu.Button
              onClick={() => {
                onEnableEditMode();
                closeMenu();
              }}
              content="Edit Field"
              icon="edit"
            />
            <Menu.Button
              onClick={() => {
                onDelete();
                closeMenu();
              }}
              content="Delete Field"
              icon="delete"
            />
          </React.Fragment>
        );
      }}
    </Menu>
  );
}

FormFieldMenu.propTypes = {
  onAddFormFieldAbove: PropTypes.func.isRequired,
  onEnableEditMode: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default FormFieldMenu;
